import { motion } from "framer-motion";

const LINES = [
  { text: "MORE LEADS", tone: "white" },
  { text: "ARE NOT THE WHOLE", tone: "muted" },
  { text: "ANSWER.", tone: "gold" },
  { text: "A SYSTEM THAT FOLLOWS UP", tone: "white" },
  { text: "IS.", tone: "gold" },
];

const toneColor = {
  white: "#F0ECE4",
  muted: "rgba(240,236,228,0.45)",
  gold: "#C9A84C",
};

export default function ReplayManifesto() {
  return (
    <section
      id="system"
      className="relative py-28 md:py-40"
      data-testid="replay-manifesto"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="mb-10 flex items-center gap-4"
        >
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#F0ECE4]/40">
            [001] —
          </span>
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#C9A84C]">
            WHAT YOU JUST WATCHED
          </span>
        </motion.div>

        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          variants={{ visible: { transition: { staggerChildren: 0.09 } } }}
          className="font-display max-w-[1200px]"
          style={{
            fontSize: "clamp(38px, 6vw, 96px)",
            lineHeight: 0.98,
            letterSpacing: "-0.035em",
          }}
        >
          {LINES.map((l) => (
            <div key={l.text} className="overflow-hidden">
              <motion.div
                variants={{
                  hidden: { y: "110%", opacity: 0 },
                  visible: {
                    y: "0%",
                    opacity: 1,
                    transition: { duration: 0.9, ease: [0.85, 0, 0.15, 1] },
                  },
                }}
                style={{ color: toneColor[l.tone] }}
              >
                {l.text}
              </motion.div>
            </div>
          ))}
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 0.65, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, delay: 0.5 }}
          className="mt-12 max-w-[620px] font-body text-[15px] leading-[1.8] text-[#F0ECE4]"
        >
          Growth compounds when lead generation, rapid follow-up, and automation
          work as one operating system — not as disconnected tools bolted
          together. What you saw in the training is one integrated view of that
          system.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.65 }}
          className="mt-10"
        >
          <a
            href="#book"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="wam-btn-ghost text-[12px]"
            data-testid="manifesto-cta"
          >
            See The Next Step →
          </a>
        </motion.div>
      </div>
    </section>
  );
}
